module.exports = __webpack_public_path__ + "1b6a2d906e37cb4e7a605b9ea416b369.svg";